<template>
	<div class="follow-order">
		<div class="box">
			<span class="title">فیلترها</span>
			<div class="row mt-3">
				<div class="col d-flex flex-column">
					<label for="html">استان:</label>
					<select @change="getCityOnChange" v-model="pickProvince" class="form-select">
						<option
							v-for="province in provinceLists"
							:value="province.id"
							:key="`province-` + province.id"
						>
							{{ province.name }}
						</option>
					</select>
				</div>
				<div class="col d-flex flex-column">
					<label for="html">شهر:</label>
					<select v-model="pickCity" class="form-select">
						<option v-for="city in cityLists" :value="city.city.id" :key="`city-` + city.city.id">
							{{ city.city.name }}
						</option>
					</select>
				</div>
				<div class="col">
					<label for="html">موبایل:</label>
					<input class="inputs" v-model="phoneNumber" />
				</div>
				<div class="col">
					<label for="html">نام:</label>
					<input class="inputs" v-model="userFirstName">
				</div>
				<div class="col">
					<label for="html">نام خانوادگی:</label>
					<input class="inputs" v-model="userLastName">
				</div>
				
				<div class="col d-flex flex-row align-items-end w-100">
					<button @click="getDataPackage((limit = 20), (offset = 0))" class="accept">تایید</button>
					<button class="remove-filtes" @click="removeFilter">حذف فیلتر</button>

					<!-- <img class="trash-icon" @click="removeFilter" src="../../assets/images/iconPack/trash-icon.png"> -->
				</div>
			</div>
			<div class="row mt-3">
				<div class="col d-flex flex-column"></div>
				<div class="col d-flex flex-column"></div>

				<div class="col"></div>
				<div class="col"></div>
				<div class="col"></div>
			</div>
		</div>
		<div class="box">
			<div class="d-flex justify-content-between">
				<pagination
					v-model="page"
					:per-page="20"
					:records="totalDataCount"
					@paginate="myCallback"
				/>
				<div class="d-flex flex-row align-items-center">
					<span class="ordering-title">مرتب سازی بر اساس تاریخ:</span>
					<b-form-select
						v-model="selected"
						:options="options"
						class="ordering"
						value-field="item"
						text-field="name"
						@change="getDataPackage((limit = 20), (offset = 0), (order = selected))"
					></b-form-select>
				</div>
			</div>
			<div>
				<Tableview
					:hover="true"
					:bordered="true"
					:showNoContent="showContnetFunc"
					:showNoData="showDataFunc"
				>
					<template #TableTitle>
						<tr>
							<th>ردیف</th>
							<th>موبایل</th>
							<th>نام و نام خانوادگی</th>
							<th>کدملی</th>
							<th>شهر</th>
							<th>نقش</th>
							<!-- <th>شماره نیروی اجرایی</th> -->
							<!-- <th>ایمیل</th> -->
							<th>عملیات</th>
							<!-- <th>وضعیت</th> -->
							<!-- <th>مشاهده</th> -->
						</tr>
					</template>

					<template #TableBody>
						<tr v-for="(item, index) in dataPackage" :key="`list-` + item.id">
							<td class="persian-number">
								{{ 20 * (page - 1) + 1 + index }}
							</td>
							<td>{{ item.user.username }}</td>
							<td>{{ item.user.first_name + ' ' + item.user.last_name }}</td>
							<td class="persian-number">{{ item.user.extended.national_code }}</td>
							<td class="persian-number">{{ item.user.extended.city && item.user.extended.city.name ? item.user.extended.city.name : '-' }}</td>
							<!-- <td>{{ item.role.verbose_name }}</td> -->
							<td>
								<select
									style="border-radius: 8px; padding: 2px"
									v-model="item.role"
									@change="changeRole(item)"
								>
									<option v-for="role in roles" :key="item.id + `-role-` + role.id" :value="role">
										{{ role.verbose_name }}
									</option>
								</select>
								<!-- <span v-if="item.status === '0'">ویزیت نشده</span>
								<span v-if="item.status === '1'">تکمیل نشده</span>
								<span v-if="item.status === '2'">تکمیل شده</span>
								<span v-if="item.status === '3'">تایید شده</span>
								<span v-if="item.status === '4'">رد شده</span> -->
							</td>
							<!-- <td>{{ item.user.email }}</td> -->
							<!-- <td class="persian-number">
								{{ item.promoter.username }}
							</td> -->
							<!-- <td class="custom-td"> -->
							<!-- <date-picker
								v-model="date"
								format="YYYY-MM-DD"
								display-format="jYYYY-jMM-jDD"
								custom-input=".custom-input"
								/> -->

							<!-- <date-picker
									v-model="item.start_datetime"
									type="datetime"
									format="YYYY-MM-DD HH:mm"
									display-format="jYYYY-jMM-jDD HH:mm"
									:timezone="true"
									:disabled="true"
								/> -->
							<!-- <span class="custom-input"></span>
								{{ item.datetime_created.substring(0, 10) }} -->
							<!-- </td> -->
							<!-- <td class="persian-number">{{ item.visit_turn }}</td> -->
							<!-- <td>
								<select style="border-radius: 8px; padding: 2px;" v-model="item.status" @change="changeVisitStatus(item)">
									<option value="0">ویزیت نشده</option>
									<option value="1">تکمیل نشده</option>
									<option value="2">تکمیل شده</option>
									<option value="3">تایید شده</option>
									<option value="4">رد شده</option>
								</select> -->
							<!-- <span v-if="item.status === '0'">ویزیت نشده</span>
								<span v-if="item.status === '1'">تکمیل نشده</span>
								<span v-if="item.status === '2'">تکمیل شده</span>
								<span v-if="item.status === '3'">تایید شده</span>
								<span v-if="item.status === '4'">رد شده</span> -->
							<!-- </td> -->
							<td>
								<img
									v-b-tooltip.hover
									title="ویرایش"
									@click="editUser(item)"
									class="eye-icon icon-complement"
									src="../../assets/images/iconPack/basil_edit-outline.svg"
								/>
								<img
									v-b-tooltip.hover
									title="تغییر رمز عبور"
									@click="openSetPasswordModal(item)"
									class="eye-icon icon-complement"
									src="../../assets/images/iconPack/lock.svg"
								/>
								<img
									v-b-tooltip.hover
									title="حذف دسترسی"
									@click="deleteUserModal(item)"
									class="eye-icon icon-complement"
									src="../../assets/images/iconPack/red-trash.svg"
								/>
							</td>
						</tr>
					</template>
				</Tableview>
			</div>
		</div>
		<b-modal v-model="showSetPasswordModal" hide-footer hide-header centered>
			<div class="p-3">
				<div class="d-flex flex-column justify-content-center">
					<!-- <div></div> -->
					<label for="#password">رمز ورود</label>
					<input
						id="password"
						class="inputs password-field"
						v-model="changedPasswordItem.user.password"
					/>
					<div class="d-flex justify-content-end mt-4">
						<button @click="setPassword" class="confirm-item">بله</button>
						<button @click="denySetPass" class="reject-item">خیر</button>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal v-model="showDeleteUserModal" hide-footer hide-header centered>
			<div class="p-3">
				<div class="d-flex flex-column justify-content-center">
					<!-- <div></div> -->
					<label for="#password">ایا از حذف خود اطمینان دارید؟</label>
					<div class="d-flex justify-content-end mt-4">
						<button @click="deleteUser" class="confirm-item">بله</button>
						<button @click="showDeleteUserModal = false" class="reject-item">خیر</button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';

export default {
	components: {
		Tableview,
		Pagination,
	},
	data() {
		return {
			dataPackage: 0,
			cityLists: [],
			promoterLists: [],
			provinceLists: [],
			pickCity: '',
			showSetPasswordModal: false,
			changedPasswordItem: { user: { password: '' } },
			dueDate: '',
			pickProvince: '',
			pickPromoter: '',
			visitTurn: '',
			phoneNumber: '',
			pickStore: '',
			selectedkCity: '',
			outletCat: [],
			page: 1,
			totalDataCount: 0,
			selected: '-user',
			userId: null,
			showDeleteUserModal: false,
			options: [
				{ item: '-user', name: 'نزولی' },
				{ item: 'user', name: 'صعودی' },
			],
			userFirstName:'',
			userLastName:'',
		};
	},
	mounted() {
		this.getDataPackage();
		this.getCity();
		this.getPromoterLists();
		this.getProvince();
		this.getOutletCat();
		this.getRoles();
	},
	computed: {
		selectedPromoterId() {
			return this.pickPromoter.id;
		},
		selectedCityId() {
			return this.pickCity.id;
		},
		selectedProvinceId() {
			return this.pickProvince.id;
		},
		showContnetFunc() {
            return this.dataPackage === 0
        },
        showDataFunc() {
            if (this.dataPackage.length !== undefined){
                return this.dataPackage.length === 0
            }
            return false
        },
	},
	methods: {
		getCityOnChange() {
			this.selectedkCity = this.pickProvince;
			this.getCity();
		},
		removeFilter() {
			this.pickCity = '';
			this.pickPromoter = '';
			this.visitTurn = '';
			this.phoneNumber = '';
			this.pickProvince = '';
			this.pickStore = '';
			this.dueDate = '';
			this.selectedkCity = '';
			this.getDataPackage();
			this.getCity();
			this.getProvince();
			this.userFirstName = '';
			this.userLastName = '';
			
		},
		async getOutletCat() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.OUTLET_CAT + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.outletCat = res.data;
			}
		},
		editUser(item) {
			item;
			let routeData = this.$router.resolve({
				name: 'userEditPage',
				params: { pn: item.user.username },
			});
			window.open(routeData.href);
		},
		openSetPasswordModal(item) {
			this.showSetPasswordModal = !this.showSetPasswordModal;
			this.changedPasswordItem = item;
			this.changedPasswordItem.user.password = '';
			item;
			// this.userEditPost(item, true);
		},
		async deleteUser() {
			const res = await this.$ApiServiceLayer.delete(
				this.$PATH.RELATIVE_PATH.DELETE.DELETE_ROLE_ASSIGNMENT +
					this.userId +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{},
			);
			if (res.status === 204) {
				this.showDeleteUserModal = false
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'کاربر با موفقیت حذف گردید',
				});
			}
			this.getDataPackage();
		},
		deleteUserModal(item) {
			this.userId = item.id;
			this.showDeleteUserModal = true;
		},
		denySetPass() {
			this.showSetPasswordModal = !this.showSetPasswordModal;
			this.changedPasswordItem = { user: { password: '' } };
		},
		async setPassword() {
			// item.user.password = this.changedPasswordItem.user.password;
			await this.setPasswordApi({
				username: this.changedPasswordItem.user.username,
				password: this.changedPasswordItem.user.password,
			});
			// (item)
			this.denySetPass();
		},
		async setPasswordApi(data) {
			// let data = item;
			// ("itemmmmmmmmm", item)
			// // data.role = undefined;
			// data.role = item.role.id;
			// data.project = item.project.id;
			// data.change_password = changePassword;
			// data.user.extended.city = item.user.extended.city.id
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.USER_SET_PASSWORD +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				'/auth',
				data,
			);
			if (res.status === 200) {
				// this.roles = res.data;
				'here roles:', this.roles;
			}
			this.getDataPackage(this.limit, this.offset);
		},
		async userEditPost(item, changePassword = false) {
			let data = item;
			'itemmmmmmmmm', item;
			// data.role = undefined;
			data.role = item.role.id;
			data.project = item.project.id;
			data.change_password = changePassword;
			data.user.extended.city = item.user.extended.city.id;
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.USER_EDIT + '?p=' + this.$STORE.state.userConfig.setProjectId,
				'',
				data,
			);
			if (res.status === 200) {
				// this.roles = res.data;
				'here roles:', this.roles;
			}
			this.getDataPackage(this.limit, this.offset);
		},
		async getDataPackage(limit = 20, offset = 0) {
			let res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_USER_LIST +
					'?city=' +
					this.pickCity +
					'&province=' +
					this.pickProvince +
					'&user__first_name='+
					this.userFirstName +
					'&user__last_name='+
					this.userLastName +
					'&user__username=' +
					this.phoneNumber +
					'&limit=' +
					limit +
					'&offset=' +
					offset +
					'&is_deleted=false' +
					'&ordering=' +
					this.selected +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
			);
			if (res.status === 200) {
				this.dataPackage = res.data.results;
				// this.dataPackage.changedRoleId = this.dataPackage.role.id;
				'here data:', this.dataPackage;
				this.totalDataCount = res.data.count;
			}
		},
		async getRoles() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.LIST_CREATE_ROLE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.roles = res.data;
				'here roles:', this.roles;
			}
		},
		// async getDataPackage(limit = 20, offset = 0) {
		// 	const res = await this.$ApiServiceLayer.get(
		// 		this.$PATH.RELATIVE_PATH.GET.GET_USER_LIST +
		// 			'?city=' +
		// 			this.pickCity +
		// 			'&province=' +
		// 			this.pickProvince +
		// 			'&user__username=' +
		// 			this.phoneNumber +
		// 			'&limit=' +
		// 			limit +
		// 			'&offset=' +
		// 			offset +
		// 			'&ordering=' +
		// 			this.selected +
		// 			'&p=' + this.$STORE.state.userConfig.setProjectId
		// 			,
		// 		'',
		// 		{},
		// 	);
		// 	if (res.status === 200) {
		// 		this.dataPackage = res.data.results;
		// 		("here data:", this.dataPackage)
		// 		this.totalDataCount = res.data.count;
		// 	}
		// },
		async myCallback() {
			await this.getDataPackage(20, 20 * (this.page - 1));
		},
		visitDetail(id) {
			let routeData = this.$router.resolve({ name: 'answerList', params: { id: id } });
			window.open(routeData.href);
		},
		async getProvince() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.provinceLists = res.data;
			}
		},
		async changeVisitStatus(item) {
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.VISITS_STATUS + item.id + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ status: item.status, rejection_reason: item.status === '4' ? 'nadarad' : '' },
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'وضعیت با موفقیت تغییر پیدا کرد!',
				});
			}
		},
		async changeRole(item) {
			this.userEditPost(item);
			// const res = await this.$ApiServiceLayer.patch(
			// 	this.$PATH.RELATIVE_PATH.MULTI.VISITS_STATUS + item.id + '/',
			// 	this.$PATH.SERVICE_NAME.AUTH,
			// 	{ status: item.status, rejection_reason: item.status === '4' ? "nadarad":'' },
			// );
			// if (res.status === 200) {
			// 	this.$notify({
			// 		group: 'tc',
			// 		type: 'success',
			// 		text: 'وضعیت با موفقیت تغییر پیدا کرد!',
			// 	});
			// }
		},
		async getCity() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST +
					'?city__province=' +
					this.selectedkCity +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				'city:', res.data;
				this.cityLists = res.data;
			}
		},
		async getPromoterLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROMOTER_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				'promoter:', res.data;
				this.promoterLists = res.data;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.confirm-item {
	background: none;
	padding: 8px;
	border: 1px solid #2d8b8b;
	border-radius: 8px;
	background: #2d8b8b;
	color: #fff;
	margin-left: 8px;
	min-width: 75px;
}
.reject-item {
	border: 1px solid #2d8b8b;
	background: #fff;
	color: #000;
	width: 75px;
	border-radius: 8px;
	color: #2d8b8b;
	padding: 8px;
}
.follow-order {
	padding: 32px 50px;
	.box {
		// border: 1px solid #c4c4c4;
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;

		.title {
			font-weight: 700;
			font-size: 18px;
		}
		.package-number {
			height: 38px;
			text-indent: 10px;
		}
		.inputs {
			width: 100%;
			height: 38px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
			font-family: 'IRANYekanfa' !important;
			border-radius: 8px;
		}
	}
	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}
	.form-select {
		width: 100%;
		border: 1px solid #c4c4c4;
		height: 38px;
		padding: 0 9px;
		border-radius: 8px;
		color: #828282;
		border-radius: 8px;
	}
	.accept {
		height: 38px;
		background: #2d8b8b;
		border-radius: 8px;
		color: #fff;
		border: none !important;
		margin-left: 10px;
		width: 100px;
		border-radius: 8px;
	}
	.remove-filtes {
		width: 50%;
		border: 1px solid #2d8b8b;
		border-radius: 8px;
		color: #2d8b8b;
		height: 38px;
		background: #fff;
		border-radius: 8px;
	}
	.ordering-title {
		min-width: 200px;
	}
	.ordering {
		max-width: 100px;
	}
	.show-date {
		border: none;
		text-indent: 55px;
		background: #fff;
	}
	.custom-td {
		min-width: 160px;
	}
	.eye-icon {
		width: 32px;
		cursor: pointer;
	}
	.icon-complement {
		padding: 0px 5px;
	}
}
</style>
<!-- <style>
.vpd-input-group label {
	height: 38px;
}
.vpd-input-group .vpd-clear-btn {
	top: 3px !important;
}
.vpd-input-group input {
	border: 1px solid #c4c4c4;
	border-radius: 8px;
}
</style> -->
<style>
.VuePagination__count {
	display: none;
}
.page-item.active .page-link {
	background-color: #2d8b8b;
	border-radius: 8px;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
